<template>
  <span class="square-symbol" :class="classes.color">
    <slot />
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface Props {
  color?: string;
  size?: string;
}

const props = withDefaults(defineProps<Props>(), {
  color: 'default',
  size: 'small',
});

const classes = computed(() => ({
  color: {
    'square-symbol--default': !props.color || props.color === 'default',
    'square-symbol--primary': props.color === 'primary',
    'square-symbol--secondary': props.color === 'secondary',
    'square-symbol--tertiary': props.color === 'tertiary',
    'square-symbol--grey': props.color === 'grey',
    'square-symbol--grey-light': props.color === 'grey-light',
    'square-symbol--accent': props.color === 'accent',
  },
  size: {
    'square-symbol--small': props.size === 'small',
  },
}));
</script>

<style lang="scss" scoped>
.square-symbol {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.3em;
  height: 1.3em;
  padding: 1px;
  border: 1px $color-base solid;
  font-size: 12px;

  &--default {
    color: $color-base;
    border-color: $color-base;
  }

  &--primary {
    color: $color-primary;
    border-color: $color-primary;
  }

  &--secondary {
    color: $color-secondary;
    border-color: $color-secondary;
  }

  &--tertiary {
    color: $color-tertiary;
    border-color: $color-tertiary;
  }

  &--grey {
    color: $color-grey;
    border-color: $color-grey;
  }

  &--grey-light {
    color: $color-grey-light;
    border-color: $color-grey-light;
  }

  &--accent {
    color: $color-accent;
    border-color: $color-accent;
  }

  &--small {
    font-size: 10px;
  }
}
</style>
